export default "__VITE_PUBLIC_ASSET__576366be__"